import { useTranslations } from 'next-intl';
import Buoy from '@monofront/design-system/visuals/Icons/Old/Buoy';
import { RoutesEnum } from '@monofront/types';
import useLocalizedRoutes from '@hooks/i18n/useLocalizedRoutes';

const NeedHelp = () => {
  const tCustomerLove = useTranslations('CustomerLove');
  const { getUrl } = useLocalizedRoutes();

  return (
    <>
      <div className="container">
        <div className="title h4b">
          <Buoy />
          {` ${tCustomerLove('needHelp')}`}
        </div>
        <p>
          {tCustomerLove.rich('link', {
            a: (children) => (
              <a
                href={getUrl(RoutesEnum.SUPPORT_NEW_REQUEST_URL)}
                target="_blank"
                rel="noreferrer"
                className="tw-lf-link-md"
                data-testid="NeedHelp-anchor"
              >
                {children}
              </a>
            ),
          })}
        </p>
      </div>
      <style jsx>
        {`
          .title {
            display: flex;
            align-items: center;
            margin-bottom: var(--space-2);
          }

          .container {
            max-width: 400px;
          }
        `}
      </style>
    </>
  );
};

export default NeedHelp;
